import React, { useState } from "react";
import { Autocomplete } from "@material-ui/lab";
import { Button, OutlinedInput, StyledGrid } from "components/simple";
import { Tag } from "types";

interface Props {
  defaultTags: Tag[];
  allTags: Tag[];
  onSave(arg0: Tag[]): void;
  onCancel(): void;
}

const TagInput = ({ defaultTags, allTags, onSave, onCancel }: Props) => {
  const [userTagsInputValue, setUserTagsInputValue] = useState<Tag[]>(
    defaultTags.sort((a: Tag, b: Tag) => a.label.localeCompare(b.label))
  );
  console.log(allTags);
  return (
    <>
      <Autocomplete
        value={userTagsInputValue}
        onChange={(event, newValue) => {
          setUserTagsInputValue(newValue);
        }}
        multiple
        id="tags-outlined"
        options={allTags}
        defaultValue={defaultTags}
        disableClearable
        getOptionSelected={(option: Tag, value: Tag) => option.id === value.id}
        getOptionLabel={option => option.label}
        filterSelectedOptions
        ChipProps={{ variant: "outlined" }}
        renderInput={params => (
          <OutlinedInput {...params} variant="outlined" label="Edit Tags" fullWidth />
        )}
      />
      <StyledGrid
        display="flex"
        justifyContent="center"
        flexWrap="wrap"
        gap="10px"
        marginTop="10px"
      >
        <Button compressed onClick={onCancel} inverted squared padding="14px">
          Cancel
        </Button>
        <Button
          compressed
          borderRadius="4px"
          onClick={() => onSave(userTagsInputValue)}
          squared
          padding="14px"
        >
          Save Tags
        </Button>
      </StyledGrid>
    </>
  );
};

export default TagInput;
